import { Link } from '@inertiajs/react';
import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface Post {
  title: string;
  excerpt: string;
  imageUrl: string;
  author: string;
  authorAvatar: string;
  date: string;
  content: string;
}

interface BlogDetailsPageProps {
  post: Post;
}

const BlogDetailsPage: React.FC<BlogDetailsPageProps> = ({ post }) => {
  return (
    <div className='animate-fade-in'>
      <div className='container mx-auto px-6 py-12 md:py-20 max-w-4xl'>
        <article>
          <header className='mb-12'>
            <Link href='/blog' className='flex items-center text-primary font-semibold mb-6 hover:underline'>
              <ArrowLeft className='h-5 w-5 mr-2' />
              Back to Blog
            </Link>
            <h1 className='text-4xl md:text-5xl font-bold text-foreground font-heading leading-tight mb-4 opacity-0 animate-fade-in-up'>
              {post.title}
            </h1>
            <div
              className='flex items-center text-muted-foreground opacity-0 animate-fade-in-up'
              style={{ animationDelay: '0.2s' }}
            >
              <img
                src={post.authorAvatar}
                alt={post.author}
                className='w-12 h-12 rounded-full mr-4 border-2 border-border'
              />
              <div>
                <p className='font-semibold text-foreground'>{post.author}</p>
                <p className='text-sm'>{post.date}</p>
              </div>
            </div>
          </header>

          <div
            className='mb-12 rounded-lg overflow-hidden shadow-xl border border-border opacity-0 animate-fade-in-up'
            style={{ animationDelay: '0.3s' }}
          >
            <img src={post.imageUrl} alt={post.title} className='w-full h-auto max-h-[500px] object-cover' />
          </div>

          <div
            className='prose prose-lg lg:prose-xl dark:prose-invert max-w-none text-muted-foreground leading-relaxed opacity-0 animate-fade-in-up'
            style={{ animationDelay: '0.4s' }}
          >
            {post.content.split('\n\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogDetailsPage;
